import React from 'react'
import Tools from './Tools';
const TableStatus = () => {
  return (
    <div>
        <div className='mb-10'>
        <div className='grid grid-cols-2 gap-[400px] lg:px-[310px] lg:mt-5 sm:px-6 sm:mt-5'>
        <div className='  border rounded-lg shadow-md  w-[800px] '>
        <div class="flex flex-col ">
            <div className='px-10 py-6'>
            <h2 className='font-bold text-lg'>Transitions</h2>
            <p className='text-gray-400 text-sm'>Ex pariatur aliquip officia dolor quis.</p>
            </div>
  <div className="-m-1.5 overflow-x-auto">
    <div className="p-1.5 min-w-full inline-block align-middle">
      <div className="overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200"><span className="inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-800/30 dark:text-green-500">
                <span className="size-1.5 inline-block rounded-full bg-green-800 dark:bg-green-500"></span>
                Completed
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200">
                <p className='font-semibold text-base'>Visa card ****4831</p>
                <p className='text-gray-400 text-sm'>Card payment</p>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200">
              <p className='font-semibold text-base'>$182.94</p>
                <p className='text-gray-400 text-sm'>Jan 17,2024</p>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-gray-400 text-sm dark:text-gray-200">Facebook</td>
              <td className="px-6 py-4 whitespace-nowrap text-end text-sm font-medium">
                 <Tools/>
              </td>
              
            </tr>

            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200">
              <span className="inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-800/30 dark:text-green-500">
                <span className="size-1.5 inline-block rounded-full bg-green-800 dark:bg-green-500"></span>
                Completed
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200">
              <p className='font-semibold text-base'>Mastercard ****6442</p>
                <p className='text-gray-400 text-sm'>Card payment</p>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200">
              <p className='font-semibold text-base'>$182.94</p>
                <p className='text-gray-400 text-sm'>Jan 17,2024</p>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-gray-400 text-sm dark:text-gray-200">Amazon</td>
                <td className="px-6 py-4 whitespace-nowrap text-end text-sm font-medium">
                <Tools/>
              </td>
            </tr>

            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200">
              <span className="inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-800/30 dark:text-yellow-500">
                <span className="size-1.5 inline-block rounded-full bg-yellow-800 dark:bg-yellow-500"></span>
                Pending
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200">
              <p className='font-semibold text-base'>Account ****882</p>
                <p className='text-gray-400 text-sm'>Bank payment</p>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200">
              <p className='font-semibold text-base'>$99.94</p>
                <p className='text-gray-400 text-sm'>Jan 17,2022</p>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-gray-400 text-sm dark:text-gray-200">Netflix</td>
                <td className="px-6 py-4 whitespace-nowrap text-end text-sm font-medium">
                <Tools/>
              </td>
            </tr>

            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200">
              <span className="inline-flex items-center gap-x-1.5 py-1.5 px-3 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-800/30 dark:text-red-500">
                <span className="size-1.5 inline-block rounded-full bg-red-800 dark:bg-red-500"></span>
                Canceled
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200">
              <p className='font-semibold text-base'>Amex card ****5666</p>
                <p className='text-gray-400 text-sm'>Card payment</p>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200">
              <p className='font-semibold text-base'>$220.22</p>
                <p className='text-gray-400 text-sm'>Jan 17,2023</p>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-gray-400 text-sm dark:text-gray-200">Amazon Prime</td>
                <td className="px-6 py-4 whitespace-nowrap text-end text-sm font-medium">
                    <Tools/>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
        </div>
        <div className='border rounded-lg shadow-md min-h-[200px] w-[500px]'>
        <div className='px-10 py-6'>
            <h2 className='font-bold text-lg'>Transitions</h2>
            <p className='text-gray-400 text-sm'>Ex pariatur aliquip officia dolor quis.</p>
            </div>
        <div className="flex-shrink-0 group mb-8 block px-5">
            <div className="flex items-center">
                <img className="inline-block flex-shrink-0 size-[40px] rounded-full" src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2&w=300&h=300&q=80" alt="Image Description" />
                <div className="ms-3">
                <h3 className="font-semibold text-base text-gray-800 dark:text-white">Mark Wanner</h3>
                <p className="text-sm font-medium  text-gray-400">mark@gmail.com</p>
                </div>
                <div className="ms-3 ml-[200px]">
                <h3 className="font-semibold text-base text-gray-800 dark:text-white">$11.32</h3>
                <p className="text-sm font-medium  text-gray-400">New York</p>
                </div>
            </div>
            </div>

            <div className="flex-shrink-0 group mb-8 block px-5">
            <div className="flex items-center">
                <img className="inline-block flex-shrink-0 size-[40px] rounded-full" src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2&w=300&h=300&q=80" alt="Image Description" />
                <div className="ms-3">
                <h3 className="font-semibold text-base text-gray-800 dark:text-white">Mark Wanner</h3>
                <p className="text-sm font-medium  text-gray-400">mark@gmail.com</p>
                </div>
                <div className="ms-3 ml-[200px]">
                <h3 className="font-semibold text-base text-gray-800 dark:text-white">$11.32</h3>
                <p className="text-sm font-medium  text-gray-400">New York</p>
                </div>
            </div>
            </div>

            <div className="flex-shrink-0 group mb-8 block px-5">
            <div className="flex items-center">
                <img className="inline-block flex-shrink-0 size-[40px] rounded-full" src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2&w=300&h=300&q=80" alt="Image Description" />
                <div className="ms-3">
                <h3 className="font-semibold text-base text-gray-800 dark:text-white">Mark Wanner</h3>
                <p className="text-sm font-medium  text-gray-400">mark@gmail.com</p>
                </div>
                <div className="ms-3 ml-[200px]">
                <h3 className="font-semibold text-base text-gray-800 dark:text-white">$11.32</h3>
                <p className="text-sm font-medium  text-gray-400">New York</p>
                </div>
            </div>
            </div>

            <div className="flex-shrink-0 group mb-8 block px-5">
            <div className="flex items-center">
                <img className="inline-block flex-shrink-0 size-[40px] rounded-full" src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2&w=300&h=300&q=80" alt="Image Description" />
                <div className="ms-3">
                <h3 className="font-semibold text-base text-gray-800 dark:text-white">Mark Wanner</h3>
                <p className="text-sm font-medium  text-gray-400">mark@gmail.com</p>
                </div>
                <div className="ms-3 ml-[200px]">
                <h3 className="font-semibold text-base text-gray-800 dark:text-white">$11.32</h3>
                <p className="text-sm font-medium  text-gray-400">New York</p>
                </div>
            </div>
            </div>
            <div className='ml-10 mb-4'>
            <a className="inline-flex items-center gap-x-1 text-sm text-blue-600 decoration-2 hover:underline font-medium dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="#">
            SEE ALL CUSTOMERS
            <svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
            </a>
            </div>
        </div>
        </div>
        </div>
    </div>
  )
}

export default TableStatus